export const FETCH_FILTER_GROUP = 'FETCH_FILTER_GROUP'
export const UPDATE_FILTER_GROUP = 'UPDATE_FILTER_GROUP'
export const UPDATE_FILTER_GROUP_TAG = 'UPDATE_FILTER_GROUP_TAG'
export const ADD_FILTER_GROUP_TAG = 'ADD_FILTER_GROUP_TAG'
export const SOURCE_ADD_FILTER_GROUP = 'SOURCE_ADD_FILTER_GROUP'
export const ADD_FILTERS = 'ADD_FILTERS'

export const FETCH_FILTER_GROUPS = 'FETCH_FILTER_GROUPS'



// WEBPACK FOOTER //
// ./src/pages/filter-group/constants.ts